function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.084 0h1.832c2.658 0 4.254.401 5.663 1.154a7.853 7.853 0 013.267 3.267C21.599 5.83 22 7.426 22 10.084v1.832c0 2.658-.401 4.254-1.154 5.663a7.853 7.853 0 01-3.267 3.267C16.17 21.599 14.574 22 11.916 22h-1.832c-2.658 0-4.254-.401-5.663-1.154a7.853 7.853 0 01-3.267-3.267C.401 16.17 0 14.574 0 11.916v-1.832C0 7.426.401 5.83 1.154 4.421a7.853 7.853 0 013.267-3.267C5.83.401 7.426 0 10.084 0z",
  id: "account_on_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "account_on_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#account_on_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#EBB300",
  strokeWidth: 1.571,
  d: "M20.153 17.208a7.079 7.079 0 01-2.945 2.945c-1.316.704-2.812 1.061-5.292 1.061h-1.832c-2.48 0-3.976-.357-5.292-1.061a7.079 7.079 0 01-2.945-2.945C1.143 15.892.786 14.396.786 11.916v-1.832c0-2.48.357-3.976 1.061-5.292a7.079 7.079 0 012.945-2.945C6.108 1.143 7.604.786 10.084.786h1.832c2.48 0 3.976.357 5.292 1.061a7.079 7.079 0 012.945 2.945c.704 1.316 1.061 2.812 1.061 5.292v1.832c0 2.48-.357 3.976-1.061 5.292z"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 1.571,
  mask: "url(#account_on_svg__b)",
  cx: 11,
  cy: 24.357,
  r: 10.214
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 1.571,
  mask: "url(#account_on_svg__b)",
  cx: 11,
  cy: 10.214,
  r: 3.929
}));

function SvgAccountOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgAccountOn;